import type { Editor } from '@tiptap/core';
import { DRAFT_SECTION_SENTINEL } from './draft-sentinel';

/**
 * Returns the ProseMirror JSON for a draft section node.
 */
export function buildDraftSectionContent() {
  return {
    type: 'sectionNode',
    attrs: {
      sectionTitle: 'New Section',
      isDraftSection: true,
    },
    content: [
      {
        type: 'heading',
        attrs: { level: 1 },
        content: [{ type: 'text', text: DRAFT_SECTION_SENTINEL }],
      },
      {
        type: 'paragraph',
        content: [],
      },
    ],
  };
}

/**
 * Inserts a draft section at the given position and focuses the heading.
 */
export function insertDraftSectionAt(editor: Editor, insertPos: number) {
  editor
    .chain()
    .focus()
    .insertContentAt(insertPos, buildDraftSectionContent())
    .setTextSelection(insertPos + 2)
    .run();
}
